import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import HerissonLogo from "@/components/HerissonLogo";
import { useAuth } from "@/lib/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Le mot de passe doit contenir au moins 6 caractères.");
    setLoading(true);
    try {
      await register(email.trim().toLowerCase(), password, name.trim());
      toast.success("Bienvenue !");
      nav("/account");
    } catch (e) { toast.error(e?.response?.data?.detail || "Échec de l'inscription"); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="card-hsg p-6">
        <div className="flex justify-center mb-2"><HerissonLogo size="md" /></div>
        <p className="text-center text-neutral-400 mb-6">Créer votre compte visiteur</p>
        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-neutral-500">Prénom / Nom</span>
            <input required value={name} onChange={(e) => setName(e.target.value)} className="mt-1 w-full bg-neutral-900 border border-neutral-700 rounded-lg px-3 py-2" data-testid="register-name" />
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-neutral-500">Email</span>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full bg-neutral-900 border border-neutral-700 rounded-lg px-3 py-2" data-testid="register-email" />
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-neutral-500">Mot de passe (6+ car.)</span>
            <input required type="password" minLength="6" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full bg-neutral-900 border border-neutral-700 rounded-lg px-3 py-2" data-testid="register-password" />
          </label>
          <button disabled={loading} type="submit" className="brand-gradient-btn w-full py-3 rounded-xl" data-testid="register-submit">
            {loading ? "…" : "Créer mon compte"}
          </button>
        </form>
        <div className="text-center mt-4 text-sm text-neutral-400">
          Déjà un compte ? <Link to="/login" className="text-[#5BC5F2]">Se connecter</Link>
        </div>
      </div>
    </div>
  );
}
